import React from 'react'

class AlertStore {
  pSubscription = null

  subscribe(fn) {
    this.pSubscription = fn
    return () => {
      this.pSubscription = null
    }
  }

  notify(value) {
    if (this.pSubscription) {
      this.pSubscription(value)
    }
  }
}

const popupStore = new AlertStore()
class Alert extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      opened: false,
      message: '',
    }
  }

  componentDidMount() {
    this.unsubscribe = popupStore.subscribe(({ opened, message }) => {
      this.setState({ opened, message })
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  static open(message = '') {
    popupStore.notify({ opened: true, message: message })
  }

  static close() {
    popupStore.notify({ opened: false, message: '' })
  }

  render() {
    const { opened, message } = this.state
    return (
      <div className={`modal modal--confirm ${opened ? 'is-active' : ''} `}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            <header className="modal__header">
              <span>Message</span>
              <button className="modal-close is-large" aria-label="close" onClick={Alert.close} />
            </header>
            <div className="modal__inner">
              <div className="modal__body">{message}</div>
              <div className="modal__section modal__actions">
                <button className="button button-gray" onClick={Alert.close}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Alert
